import { UserManager } from "oidc-client-ts";
import oidcConfig from "./oidcConfig";

// A single UserManager instance shared between OidcAuthBoundary's
// AuthProvider (React) and the axios request interceptor (outside React) -
// see docs/specs/0001-oidc-migration.md. Both must read the exact same
// session state; react-oidc-context would otherwise construct its own
// UserManager from settings, giving the interceptor no way to reach it.
const userManager = new UserManager(oidcConfig);

export default userManager;
